import { CircularProgress, styled } from '@mui/material';
import { theme } from 'assets/themes/zizzi';

const spinnerColor = theme.palette.white;

export const ViewFinder = styled('div')`
  display: flex;
`;

export const SpinnerWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
`;

export const Spinner = styled(CircularProgress)`
  svg {
    color: ${spinnerColor};
  }
`;
